export const variables = {
  // ------------------------------------------------------------------------------------------------------
  // Colors
  // ------------------------------------------------------------------------------------------------------
  colors: {
    black: '#000000', // -------------- Black
    white: '#ffffff', // -------------- White
    error: '#e10000', // -------------- Error
    transparent: 'transparent', // ---- Transparent
    mainBlue: '#1F4575', // ----------- Dark blue
    mariner: '#2C7FBE', // ------------ Medium blue
    lightBlue: '#32BAFA', // ---------- Light blue
    mainOrange: '#D95725', // --------- Dark orange
    salmon: '#FF8C69', // ------------- Light orange
    codGray: '#1C1C1C', // ------------ Very dark gray
    mineShaft: '#2B2B2B', // ---------- Dark gray
    riverBed: '#404d5b', // ----------- Dark bluish-gray
    slateGray: '#6a7989', // ---------- Medium dark gray-blue
    raven: '#7B7E86', // -------------- Medium gray-blue
    osloGray: '#7f8994', // ----------- Light gray-blue
    alto: '#D9D9D9', // --------------- Light gray
    mercury: '#E3E3E3', // ------------ Very light gray
    iron: '#E2E2E4', // --------------- Light gray with a hint of blue
    gallery: '#EDEDED', // ------------ Very light gray
    athensGray: '#F0F2F4', // --------- Very light gray with a hint of blue
    whisper: '#F2F1F7', // ------------ Very light grayish-purple
    concrete: '#F3F3F3', // ----------- Very light gray
    wildSand: '#F4F4F4', // ----------- Very light gray
    alabaster: '#F7F7F7', // ---------- Very light gray
    havelockBlue: '#4A90E2', // ------- Light blue
    lima: '#68af1c', // --------------- Light green
    fernFrond: '#568028', // ---------- Dark green
    ripeLemon: '#F8E71C', // ---------- Light yellow
    buttercup: '#F5A623', // ---------- Medium light yellow
    purple: '#8A2BE2', // ------------- Dark purple
    cinnabar: '#E34234', // ------------ Cinnabar (medium red)
    monza: '#D0021B', // -------------- Light red
    redBerry: '#8B0000', // ----------- Dark red
    mountainMeadow: '#10b981', // ----- Mountain Meadow
    flamingo: '#EF4444', // ----------- Flamingo
    dodgerBlue: '#1890ff', // --------- Dodger Blue
    lightDodgerBlue: '#69c0ff', // ---- Light Dodger Blue
    limeGreen: '#52c41a', // ---------- Lime Green
    lightLimeGreen: '#95de64', // ----- Light Lime Green
    amber: '#d97706', // -------------- Amber
    violet: '#8b5cf6', // ------------- Violet (lighter purple)
    gold: '#FFD700', // --------------- Gold
    brightBlue: '#3b82f6', // --------- Bright Blue
    darkNavy: '#1e3a5f', // ----------- Dark Navy
    mediumNavy: '#2d5a87', // --------- Medium Navy
    purpleGradientStart: '#667eea', // - Purple Gradient Start
    purpleGradientEnd: '#764ba2', // --- Purple Gradient End
    purpleGradientStartDark: '#5568d6', // Purple Gradient Start (hover)
    purpleGradientEndDark: '#653d8e', // - Purple Gradient End (hover)
    ghostWhite: '#f8f9fa', // --------- Ghost White (very light cool gray)
    snow: '#fafafa', // --------------- Snow (near white)
    whiteSmoke: '#f5f5f5', // --------- White Smoke
    platinum: '#f0f0f0', // ----------- Platinum (very light gray)
    gainsboro: '#e8e8e8', // ---------- Gainsboro
    silver: '#e0e0e0', // ------------- Silver
    dustyGray: '#999999', // ---------- Dusty Gray
    gray: '#888888', // --------------- Gray
    dimGray: '#666666', // ------------ Dim Gray
    emperor: '#555555', // ------------ Emperor (dark gray)
    mirage: '#1a1a2e', // ------------- Mirage (dark navy)
    ebony: '#000103', // -------------- Ebony (near-black)
    ebonyClay: '#1e2631', // ---------- Ebony Clay (dark blue-gray)
    oxfordBlue: '#1e293b', // --------- Oxford Blue (dark slate border)
    midnightNavy: '#0F1932', // ------- Midnight Navy (very dark blue)
    brightOrange: '#ff6b35', // ------- Bright Orange
    carrotOrange: '#f7931e', // ------- Carrot Orange
    tangerine: '#fa8c16', // ---------- Tangerine
    rajah: '#ff9a5a', // -------------- Rajah (peachy orange)
    coralRed: '#ff4d4f', // ----------- Coral Red
    lightCoral: '#ff7875', // --------- Light Coral
    chestnutRose: '#d9534f', // ------- Chestnut Rose
    mantis: '#73d13d', // ------------- Mantis (bright green)
    forestGreen: '#389e0d', // -------- Forest Green
    jade: '#059669', // --------------- Jade (teal green)
    danube: '#4a90d9', // ------------- Danube (medium blue)
    malibu: '#69b1ff', // ------------- Malibu (light sky blue)
    lavender: '#e8eaf6', // ----------- Lavender
    periwinkle: '#c5cae9', // --------- Periwinkle
    oldLace: '#fff7e6', // ------------ Old Lace (warm off-white)
    champagne: '#fff1d6', // ---------- Champagne (warm cream)
    honeydew: '#f6ffed', // ----------- Honeydew (cool green-white)
    mintCream: '#e6ffe6', // ---------- Mint Cream (light green)
    royalPurple: '#722ed1', // ------- Royal Purple
    royalBlue: '#4169e1', // --------- Royal Blue
    brightTurquoise: '#08e8de', // --- Bright Turquoise
    magnolia: '#f9f0ff', // ---------- Magnolia (light purple tint)
    pomegranate: '#f5222d', // ------- Pomegranate (bright red)
    lavenderBlush: '#fff1f0', // ----- Lavender Blush (light red tint)
    googleBlue: '#4285f4', // --------- Google Blue
    facebookBlue: '#1877f2', // ------- Facebook Blue
    yogaPurple: '#7c3aed', // --------- Yoga Purple
    yogaPurpleLight: '#a78bfa', // ---- Yoga Purple Light (gradient end)
    runningGreen: '#16a34a', // ------- Running Green
    runningGreenLight: '#4ade80', // -- Running Green Light (gradient end)
    outdoorTeal: '#0d9488', // -------- Outdoor Teal
    outdoorTealLight: '#2dd4bf', // --- Outdoor Teal Light (gradient end)

    // ------------------------------------------------------------------------------------------------------
    // Transparent colors
    // ------------------------------------------------------------------------------------------------------
    getTransparentColor: (color, opacity) => {
      const hexToRgb = (hex) => {
        const bigint = parseInt(hex.slice(1), 16);
        const r = (bigint >> 16) & 255;
        const g = (bigint >> 8) & 255;
        const b = bigint & 255;

        return `${r}, ${g}, ${b}`;
      };

      return `rgba(${hexToRgb(color)}, ${opacity})`;
    },
  },
};
